import React from "react";
import classNames from "classnames";

const H1 = ({children, className, ...rest}) => {
    return <h1 className={classNames('ff-lora', className)} {...rest}>{children}</h1>
}

export default H1
